import { MdlDialogService, IMdlCustomDialogConfiguration } from '@angular-mdl/core';
import { Component, Inject } from '@angular/core';

import { ActionsMenuAgRendererComponent, ActionsMenuItem } from '../../covance-ag-grid/renderers/actions-menu-ag-renderer-base';
import { EmailAddressFormDialog, EMAIL, USER_PK } from './email-address-form-dialog.component';
import { Email, EmailPreferenceReadModel } from './email';
import { ActionsMenuColumn } from '../../shared/grid-columns';
import { EMAIL_PREFERENCE_STORAGE_TOKEN, EmailPreferencesStorage } from './email-preferences-storage';

@Component({
    selector: 'email-menu-ag-renderer',
    template: require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.html'),
    styles: [require('../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.scss')],
})
export class EmailActionsMenuAgRendererComponent extends ActionsMenuAgRendererComponent<EmailPreferenceReadModel> {
    constructor(
        @Inject(EMAIL_PREFERENCE_STORAGE_TOKEN)private readonly emailPreferencesStorage: EmailPreferencesStorage,
        private readonly dialogService: MdlDialogService
    ) {
        super();
    }

    public createMenuItems(gridData: EmailPreferenceReadModel, colDef: ActionsMenuColumn<EmailPreferenceReadModel>): ActionsMenuItem[] {
        const nonDefaultMenuItems = [
            {
                title: 'Edit e-mail',
                onClick: () => this.editEmail(gridData.email, colDef.userId)
            },
        ];

        const allMenuItems = [
            {
                title: 'Reset preferences to default',
                onClick: () => this.emailPreferencesStorage.resetToDefault(gridData.emailPreferences, colDef.userId)
            }
        ];

        if (!gridData.email.isDefault) {
            allMenuItems.unshift(...nonDefaultMenuItems);
        }

        return allMenuItems;
    }

    private async editEmail(email: Email, userId: number) {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: EmailAddressFormDialog,
            providers: [
                { provide: EMAIL, useValue: email },
                { provide: USER_PK, useValue: userId },
                { provide: EMAIL_PREFERENCE_STORAGE_TOKEN, useValue: this.emailPreferencesStorage}
            ],
            isModal: true,
            clickOutsideToClose: true
        };

        await this.dialogService.showCustomDialog(configDialog);
    }
}
